import React from 'react';
import { getTokenValue, Text, XStack, Token } from 'tamagui';
import { hexToRGBA } from 'tamagui-config';

interface MenuItemProps {
  icon: React.ReactNode;
  label: string;
  isActive?: boolean;
  onPress?: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({ icon, label, isActive = false, onPress }) => {
  const gradientStartColor = getTokenValue('$hgPrimaryGradientStart' as Token, 'color');
  const gradientEndColor = getTokenValue('$hgPrimaryGradientEnd' as Token, 'color');
  const elevatedShadowColor = getTokenValue('$hgPrimary' as Token, 'color');

  const gradient = `linear-gradient(106deg, ${gradientStartColor} 0%, ${gradientEndColor} 100%)`;
  const boxShadow = `0px 4px 24px 0px ${hexToRGBA(elevatedShadowColor, 0.25)}`;

  return (
    <XStack
      marginHorizontal="$5"
      backgroundColor={isActive ? undefined : '$gray3'}
      backgroundImage={isActive ? gradient : undefined}
      boxShadow={isActive ? boxShadow : undefined}
      borderRadius={36}
      padding="$3.5"
      alignItems="center"
      gap="$3.5"
      pressStyle={{ opacity: 0.8 }}
      onPress={onPress}>
      {icon}
      <Text color="$textLight" fontSize="$8.5" fontFamily="$body">
        {label}
      </Text>
    </XStack>
  );
};
